<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasFoodSupplier="true"
      :hasFoodStatusType="true"
      :hasFoodKind="true"
      :hasFood="true"
      :hasSalPriceSeperate="true"
      :hasTradeStatusType="true"
      :hasCostType="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      columns: [
        { name: "SupplierNumber" },
        { name: "SupplierName" },
        { name: "FoodNumber" },
        { name: "FoodName" },
        { name: "Unit" },
        { name: "Qty" },
        { name: "SalPrice" },
        { name: "Total" },
        { name: "Cost" },
        { name: "TotalCost" },
        { name: "DiscountPrice" },
      ],
      items: [],
      pagination: {},
    };
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getSupplierFoodSale(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getSupplierFoodSale(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printSupplierFoodSale(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getSupplierFoodSale(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
